import { render } from "./lottery_list.vue?vue&type=template&id=153f5f1b"
import script from "./lottery_list.vue?vue&type=script&lang=js"
export * from "./lottery_list.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__